export default __webpack_public_path__ + "static/media/icon.bea06a47.svg";